import { SlotTariffa } from "../tabellone/SlotTariffa";

export interface Orari {
  oraInizio: string;
  oraFine: string;
}

export function gruppaOrari(slotsTariffe: { [k: string]: SlotTariffa }) {
  const Tariffe_Calendario_Orario: Orari[] = [];

  Object.values(slotsTariffe)
    .sort((a, b) => a.oraInizioDate.getTime() - b.oraInizioDate.getTime())
    .forEach((orario) => {
      if (Tariffe_Calendario_Orario.length < 1)
        Tariffe_Calendario_Orario.push({
          oraInizio: orario.oraInizio,
          oraFine: orario.oraFine,
        });
      else {
        const last = Tariffe_Calendario_Orario[Tariffe_Calendario_Orario.length - 1];
        if (last.oraFine === orario.oraInizio) {
          last.oraFine = orario.oraFine;
        } else {
          Tariffe_Calendario_Orario.push({
            oraInizio: orario.oraInizio,
            oraFine: orario.oraFine,
          });
        }
      }
    });

  return Tariffe_Calendario_Orario;
}
